import { render, staticRenderFns } from "./datasource-form.vue?vue&type=template&id=d43d47ec&scoped=true&"
import script from "./datasource-form.vue?vue&type=script&lang=ts&"
export * from "./datasource-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43d47ec",
  null
  
)

export default component.exports